import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class LogoutService {
  static logout() {
    return HttpUtil.get(API_ROUTES.LOGOUT.LOGOUTAPI);
  } 
}
